import Vue from 'vue'
import axios from 'axios'
import { mutations } from './store/index.js'
import VueLazyload from 'vue-lazyload';
import 'element-ui/lib/theme-chalk/index.css'
import { Message } from 'element-ui'
import { LOGIN_URL } from "./utils/constant.js";
import el from 'element-ui'
Vue.use(el)

// axios
Vue.prototype.$ax = axios

Vue.use(VueLazyload, {
    error: '', //请求失败后显示的图片
    loading: '', //默认展位的图片，加载中
    attempt: 1 // 这个是加载图片数量
});

// 处理用户过期清除相关信息
const handleExpireOut = function() {
	// 清除store里面的数据
	mutations('login_st')
	mutations('cloud_st')
	localStorage.removeItem('userName')
	localStorage.removeItem('expiresTime')
};

// 用每个接口返回的header里面的Date来比较登录接口返回的过期时间判断是否过期
const judgeLoginStatus = function(date) {
	try {
		let expiresTime = localStorage.getItem('expiresTime');
		if(date && expiresTime) {
			if(new Date(date).getTime() > new Date(new Date(expiresTime)).getTime()) {
				handleExpireOut()
			}
		}
	}
	catch(err) {

	}
}


// post请求时自动qs转化
axios.defaults.transformRequest = [function (data) {
	data = require('qs').stringify(data)
	return data
}];

// axios拦截，直接返回response.data.data
axios.interceptors.response.use(function (response) {
	judgeLoginStatus(response.headers.Date || response.headers.date)
	if ((response.data.status) || (response.data.code === 2000)) {
		return response.data
	} else if (response.data.code === 3001 && response.config.url !== '/api/auth/v1/user/info') {
		Message({
			type: 'warning',
			message: response.data.msg
		})
		handleExpireOut();
		localStorage.removeItem('token')
		location.href = LOGIN_URL + '?redirect_url=' + encodeURIComponent(location.href)
	} else if (response.data.code === 3001 && response.config.url === '/api/auth/v1/user/info'){
		Message({
			type: 'warning',
			message: response.data.msg
		})
		handleExpireOut();
		localStorage.removeItem('token')
		location.href = window.location.origin
	} else if (response.data.code === 4010) {
		// 如果code码是4010，即需要验证滑块登录，就不需要禁用提示信息了（用户不需要知道这块的逻辑提示）
		return Promise.reject(response)
	} else {
		Message({
			 type: 'error',
			 message: response.data.msg
		})
		return Promise.reject(response)
	}
}, function () {
	Message({
		 type: 'error',
		 message: '网络发生错误'
	})
	return Promise.reject()
})



// WEBPACK FOOTER //
// ./src/dependence.js